import { Component, ViewChild } from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NotificationRemindersService } from '../../core/services/notification-reminders/notification-reminders.service';
import { AlertService } from '../../core/services/alert/alert.service';
import { FormAddReminderComponent } from './form-add-reminder/form-add-reminder.component';

@Component({
  selector: 'app-notification-reminders',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    FormAddReminderComponent,
    RouterLink
  ],
  templateUrl: './notification-reminders.component.html',
  styleUrl: './notification-reminders.component.css',
})
export class NotificationRemindersComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  showForm = false;
  dataSource = new MatTableDataSource<any>();
  reminderData?: any;

  // Server-side pagination
  totalRecords = 0;
  pageSize = 25;
  currentPage = 1;

  displayedColumns: string[] = [
    'title',
    'channels',
    'target_users',
    'rowActions',
  ];

  constructor(
    private remindersService: NotificationRemindersService,
    private alertService: AlertService,
  ) {}

  ngAfterViewInit() {
    this.fetchData();
  }

  fetchData(): void {
    this.alertService.loading();
    const params = {
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString(),
      sortColumn: 'id',
      sortDirection: 'desc',
    };
    this.remindersService.getReminders(params).subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        this.totalRecords = response.meta?.total || 0;
        this.alertService.close();
      },
      error: (error) => {
        console.error('Error loading reminders:', error);
        this.alertService.close();
      },
    });
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.fetchData();
  }

  toggleForm() {
    this.reminderData = null;
    this.showForm = !this.showForm;
  }

  cerrarFormulario() {
    this.reminderData = null;
    this.showForm = false;
  }

  refrescar() {
    this.showForm = false;
    this.reminderData = null;
    this.fetchData();
  }

  editReminder(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');
    this.remindersService.getReminder(reference).subscribe({
      next: (response) => {
        this.alertService.close();
        this.reminderData = response.data;
        this.showForm = true;
      },
      error: () => {
        this.alertService.error('swal_messages.notification_reminders.not_found');
      },
    });
  }

  deleteReminder(reference: string): void {
    this.alertService
      .confirmation2(
        'swal_messages.notification_reminders.delete_reminder',
        'swal_messages.notification_reminders.delete_reminder_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');
          this.remindersService.deleteReminder(reference).subscribe({
            next: () => {
              this.fetchData();
            },
            error: (error) => {
              if (error.status === 409) {
                this.alertService.error('swal_messages.notification_reminders.reminder_in_use');
              } else {
                this.alertService.error(error.error?.errors || 'swal_messages.error');
              }
            },
          });
        }
      });
  }

  getChannelIcons(channels: string[]): string {
    if (!channels) return '';
    return channels.map(c => c === 'email' ? 'icon-envelope' : 'icon-bell2').join(' ');
  }
}
